import { Button, Checkbox, Input, message, Radio, Typography } from "antd";
import { format } from "date-fns";
import { useFormik } from "formik";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getCategories } from "../../../../controller/services/common";
import {
  GetIncomeDetails,
  UpdateIncome,
} from "../../../../controller/services/profile-stepper";
import i18n from "../../../../localization/i18n";
import {
  setAnsweredQuestions,
  setInfoContent,
  setInnerStepper,
  setLoading,
  setMenuTitle,
  setStepperStatus,
  setTotalQuestions,
} from "../../../../redux/slices/common_slice";
import { setIncomeData } from "../../../../redux/slices/form_slice";
import { routePaths } from "../../../../routing/routePaths";
import {
  formatNumber,
  getErrorDataClassName,
  handleKeyDown,
  isFalsyExceptZero,
} from "../../../../utils/helper";
import CreateProfileCardWrapper from "../../CreateProfileCardWrapper";
import CreateProfileCenterWrapper from "../../CreateProfileCenterWrapper";
import CreateProfileFooter from "../../CreateProfileFooter";
import CreateProfileHeader from "../../CreateProfileHeader";

const Employment = ({ formik }) => {
  const userData = useSelector((state) => state.form.userData);
  const { t } = useTranslation();
  return (
    <>
      <CreateProfileCardWrapper>
        <h5>
          {userData?.livingInCanada === "yes"
            ? t("income.ques1.title")
            : "Do you have a job lined up for when you arrive in Canada?"}
        </h5>
        <Radio.Group
          className="w-100"
          defaultValue={1}
          name="employment"
          value={formik.values?.employment}
          onChange={(e) => {
            if (e.target.value === "no" && formik.values.howMuchMoney != 0) {
              formik.setFieldValue("howMuchMoney", 0);
            }
            formik.handleChange(e);
          }}
        >
          <ul className="list-inline mb-0">
            <li>
              <Radio value={"yes"}>{t("income.ques1.options.1")}</Radio>
            </li>
            <li>
              <Radio value={"no"}>{t("income.ques1.options.2")}</Radio>
            </li>
          </ul>
        </Radio.Group>
        {formik.errors["employment"] && formik.touched["employment"] && (
          <Typography textAlign={"left"} variant="body2" color="red">
            {formik.errors["employment"]}
          </Typography>
        )}
      </CreateProfileCardWrapper>
      {formik.values?.employment === "no" && (
        <div className="row if-no-select-show-screen mb-bottom-24">
          <div className="col-12 col-sm-12 col-md-8 col-lg-8 col-xl-9">
            <h5 className="mb-0 w-auto">{t("income.resources.2")}</h5>
          </div>
          <div className="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-3">
            <Button
              className="no-employee-btn"
              onClick={() =>
                window.open("https://www.jobbank.gc.ca/findajob/newcomers")
              }
            >
              {t("newTab")}
            </Button>
          </div>
        </div>
      )}
    </>
  );
};

const UserWork = ({ formik }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  return (
    <>
      <CreateProfileCardWrapper>
        <h5 className="d-flex align-items-center justify-content-between">
          {t("income.ques3.title")}
          <Button
            className="border-0 bg-tranaparent w-auto h-auto shadow-none p-0 info-icon-btn"
            onClick={() => {
              dispatch(setInfoContent(t("income.resources.3")));
            }}
          >
            <img
              src="/assets/images/icons/info-circle-icon.svg"
              alt=""
              className="img-fluid"
            />
          </Button>
        </h5>
        <Radio.Group
          className="custom-radio-select-button"
          name="jobType"
          value={formik.values.jobType}
          onChange={formik.handleChange}
        >
          <Radio.Button value="full-time">
            {t("income.ques3.options.1")}
          </Radio.Button>
          <Radio.Button value="part-time">
            {t("income.ques3.options.2")}
          </Radio.Button>
          <Radio.Button value="not-sure">
            {t("income.ques3.options.3")}
          </Radio.Button>
        </Radio.Group>
        {formik.errors["jobType"] && formik.touched["jobType"] && (
          <Typography textAlign={"left"} variant="body2" color="red">
            {formik.errors["jobType"]}
          </Typography>
        )}
      </CreateProfileCardWrapper>
    </>
  );
};

const MoneyMaking = ({ formik }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  return (
    <CreateProfileCardWrapper>
      <h5 className="d-flex align-items-center justify-content-between">
        {t("income.ques4.title")}
        <Button
          className="border-0 bg-tranaparent w-auto h-auto shadow-none p-0 info-icon-btn"
          onClick={() => {
            dispatch(setInfoContent(t("income.resources.4")));
          }}
        >
          <img
            src="/assets/images/icons/info-circle-icon.svg"
            alt=""
            className="img-fluid"
          />
        </Button>
      </h5>
      <p>{t("income.ques4.helperText")}</p>
      <Radio.Group
        className="custom-radio-select-button custom-radio-select-custom"
        name={"incomeFrequency"}
        onChange={formik.handleChange}
        value={formik.values.incomeFrequency}
      >
        <Radio.Button value="monthly">
          {t("income.ques4.options.1")}
        </Radio.Button>
        <Radio.Button value="bi-weekly">
          {t("income.ques4.options.2")}
        </Radio.Button>
        <Radio.Button value="weekly">
          {t("income.ques4.options.3")}
        </Radio.Button>
        <Radio.Button value="annually">
          {t("income.ques4.options.4")}
        </Radio.Button>
      </Radio.Group>
      {formik.errors["incomeFrequency"] &&
        formik.touched["incomeFrequency"] && (
          <Typography textAlign={"left"} variant="body2" color="red">
            {formik.errors["incomeFrequency"]}
          </Typography>
        )}
      <h5 className="d-flex align-items-center mt-3 justify-content-between">
        {t("income.ques5.title")}
        <Button
          className="border-0 bg-tranaparent w-auto h-auto shadow-none p-0 info-icon-btn"
          onClick={() => {
            dispatch(setInfoContent(t("income.resources.5")));
          }}
        >
          <img
            src="/assets/images/icons/info-circle-icon.svg"
            alt=""
            className="img-fluid"
          />
        </Button>
      </h5>
      <Input
        rootClassName="amount-data-input"
        style={{
          marginTop: "15px",
        }}
        prefix={formik.values?.howMuchMoney ? "$" : ""}
        placeholder={t("income.ques5.placeholder")}
        name="howMuchMoney"
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        value={formatNumber(formik.values?.howMuchMoney)}
        onKeyDown={handleKeyDown}
        min={0}
        step={0.01}
        suffix={
          <img
            src="/assets/images/icons/primary-check-icon.svg"
            alt=""
            className=""
            style={
              formik.values.howMuchMoney && !formik.errors.howMuchMoney
                ? { display: "block" }
                : { display: "none" }
            }
          />
        }
        className={getErrorDataClassName("howMuchMoney", formik)}
      />
      {formik.errors["howMuchMoney"] && formik.touched["howMuchMoney"] && (
        <Typography textAlign={"left"} variant="body2" color="red">
          {formik.errors["howMuchMoney"]}
        </Typography>
      )}
    </CreateProfileCardWrapper>
  );
};

const AdditionalIncomeCaregories = ({
  formik,
  handleEditableStep,
  IS_REVIEW,
}) => {
  const { t } = useTranslation();
  const [incomeCategories, setIncomeCategories] = useState([]);
  const dispatch = useDispatch();
  const inputRef = useRef();
  const handleCheckChange = (type) => {
    const categories = [...formik.values.categories]?.filter(
      (i) => i.type.en != type?.en
    );
    const arr = categories.map((i) => {
      return {
        type: i,
        amount: "",
      };
    });
    formik.setFieldValue("incomeArr", arr);
    formik.setFieldValue("categories", categories);
  };

  useEffect(() => {
    getCategoriesList();
  }, []);
  const getCategoriesList = () => {
    dispatch(setLoading(true));
    getCategories("income")
      .then((resp) => {
        setIncomeCategories(resp.data.category);
      })
      .catch((Err) => {
        message.error(Err.message[i18n.language]);
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };
  const removeFocus = () => {
    if (inputRef.current) {
      inputRef.current.blur();
    }
  };
  return (
    <CreateProfileCardWrapper>
      <h5>
        {t("income.ques6.title")}
      </h5>
      <p>{t("income.ques6.helperText")}</p>
      <Checkbox.Group
        className="custom-checkbox-select-button"
        name={"categories"}
        style={{ width: "100%" }}
        ref={inputRef}
        onChange={(e) => {
          const incomeArr = [...formik.values?.incomeArr];
          let initArr = [];
          formik.setFieldValue("categories", e);
          initArr = incomeCategories
            .filter((i) => e.some((n) => n === i.title.en))
            .map((i) => i.title)
            .map((i) => {
              return {
                type: i,
                title:
                  incomeArr?.find(
                    (n) => i.en === n.type.en && !n?.isManuallyAdded
                  )?.title || "",
                amount:
                  incomeArr?.find(
                    (n) => i.en === n.type.en && !n?.isManuallyAdded
                  )?.amount || "",
              };
            });
          incomeArr.forEach((item) => {
            if (item?.isManuallyAdded) {
              initArr.push(item);
            }
          });
          formik.setFieldValue("incomeArr", initArr);
          removeFocus();
          if (IS_REVIEW) {
            handleEditableStep(4);
          }
        }}
        onBlur={formik.handleBlur}
        value={formik.values?.categories}
      >
        <ul className="list-inline mb-0 additional-income-list">
          {incomeCategories?.length > 0 &&
            incomeCategories?.map((item) => {
              return (
                <li className="list-inline-item" key={item?.title?.en}>
                  <Checkbox
                    className="additional-income-btn"
                    value={item?.title?.en}
                  >
                    {item.title?.[i18n.language]}
                    <img
                      src="/assets/images/icons/close-icon-white-small.svg"
                      alt=""
                      className="img-fluid close-icon-img"
                      onClick={() => handleCheckChange(item.title)}
                    />
                  </Checkbox>
                </li>
              );
            })}
        </ul>
      </Checkbox.Group>
    </CreateProfileCardWrapper>
  );
};

const AdditionalIncome = ({
  formik,
  editableStep,
  handleEditableStep,
  innerStepper,
  IS_REVIEW,
}) => {
  const dispatch = useDispatch();
  const userData = useSelector((state) => state.form.userData);
  const { t } = useTranslation();
  const handleRemoveCategory = (item) => {
    const filteredCategories = formik.values.categories.filter(
      (i) => i?.en != item.type?.en || i?.en != item.type
    );
    const filteredIncomeArr = formik.values.incomeArr.filter((i) => {
      if (item.isManuallyAdded) {
        return i.type != item.type;
      }
      return i.type?.en != item.type?.en;
    });
    formik.setFieldValue("categories", filteredCategories);
    formik.setFieldValue("incomeArr", filteredIncomeArr);
  };

  useEffect(() => {
    getCategoriesList();
  }, [formik.values?.incomeArr?.length]);
  const getCategoriesList = () => {
    dispatch(setLoading(true));
    getCategories("income")
      .then((resp) => {
        if (
          resp.data.category?.length > 0 &&
          formik.values?.incomeArr?.length > 0
        ) {
          const incomeArr = [...formik.values?.incomeArr];
          let initArr = [];
          
          const filteredCategories = resp.data.category
            .filter((i) =>
              formik.values?.incomeArr.some(
                (n) =>
                  (n.type?.en === i.title?.en || n?.type === i.title.en) &&
                  !n?.isManuallyAdded
              )
            )
            .map((i) => i.title);
          if (filteredCategories?.length > 0) {
            filteredCategories.forEach((i) => {
              initArr.push({
                type: i,
                title:
                  incomeArr?.find(
                    (n) =>
                      (i.en === n.type?.en || i.en === n.type) &&
                      !n?.isManuallyAdded
                  )?.title || "",
                amount:
                  incomeArr?.find(
                    (n) =>
                      (i.en === n.type?.en || i.en === n.type) &&
                      !n?.isManuallyAdded
                  )?.amount || "",
              });
            });
          }
          incomeArr.forEach((item) => {
            if (item?.isManuallyAdded) {
              initArr.push(item);
            }
          });
          formik.setFieldValue("incomeArr", initArr);
        }
      })
      .catch((Err) => {
        message.error(Err.message[i18n.language]);
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };

  const getCategoryGeneralInfo = (type) => {
    if (type === "Government support") {
      const obj = {
        content: (
          <div className="row if-no-select-show-screen mb-bottom-24">
            <div className="col-12 col-sm-12 col-md-8 col-lg-8 col-xl-9">
              <h5 className="mb-0 w-auto">{t("income.additionalIncome.1")}</h5>
            </div>
            <div className="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-3">
              <Button
                className="no-employee-btn"
                onClick={() => {
                  if (i18n.language === "fr") {
                    window.open("https://benefitswayfinder.org/fr");
                  } else {
                    window.open("https://benefitswayfinder.org");
                  }
                }}
              >
                {t("newTab")}
              </Button>
            </div>
          </div>
        ),
        isGreenBox: true,
      };
      return obj;
    }
    if (type === "Canada Child Benefit") {
      const obj = {
        content: (
          <div className="row if-no-select-show-screen mb-bottom-24">
            <div className="col-12 col-sm-12 col-md-8 col-lg-8 col-xl-9">
              <h5 className="mb-0 w-auto">{t("income.additionalIncome.2")}</h5>
            </div>
            <div className="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-3">
              <Button
                className="no-employee-btn"
                onClick={() =>
                  window.open(
                    "https://www.canada.ca/en/revenue-agency/services/child-family-benefits/canada-child-benefit-overview.html"
                  )
                }
              >
                {t("newTab")}
              </Button>
            </div>
          </div>
        ),
        isGreenBox: true,
      };
      return obj;
    } else if (type === "Family support") {
      return t("income.additionalIncome.3");
    } else if (type === "Foreign income" || type === "Forign Income") {
      return t("income.additionalIncome.4");
    } else if (type === "GIC") {
      return t("income.additionalIncome.5");
    } else if (type === "Others") {
      return "This is money you make on the side. Maybe you offer occasional childcare, drive for Uber on the weekend, or sell handmade goods online. All that counts as income!";
    }
  };

  return (
    <div className="row mx-0 profile-second-card-row">
      <div className="col-12">
        <div className="row">
          <div className="col-12">
            {IS_REVIEW && !editableStep && (
              <div className="d-flex justify-content-end mb-3">
                <Button
                  className="auth-theme-btn auth-theme-btn-outline theme-inner-btn d-flex align-items-center"
                  onClick={() => handleEditableStep(4)}
                >
                  {t("editBtn")}
                </Button>
              </div>
            )}
            {formik.values.incomeArr?.length > 0 &&
              (editableStep == 4 || (IS_REVIEW && editableStep)
                ? formik.values.incomeArr.map((item, index) => {
                    const obj = getCategoryGeneralInfo(item.type?.en);
                    return (
                      <>
                        <CreateProfileCardWrapper collapseInnerCard>
                          <h5 className="d-flex align-items-center justify-content-between w-100">
                            <div className="d-flex align-items-center">
                              {item?.isManuallyAdded
                                ? t("income.ques6.btnTitle")
                                : item.type?.[i18n.language]}
                              {!item?.isManuallyAdded &&
                                typeof obj === "string" && (
                                  <Button
                                    style={{ marginLeft: "10px" }}
                                    className="border-0 bg-tranaparent w-auto h-auto shadow-none p-0 me-1"
                                    onClick={() => {
                                      dispatch(setInfoContent(obj));
                                    }}
                                  >
                                    <img
                                      src="/assets/images/icons/info-circle-icon.svg"
                                      alt=""
                                      className="img-fluid"
                                    />
                                  </Button>
                                )}
                            </div>
                            <div className="d-flex align-items-center justify-content-end">
                              <Button className="p-0 w-auto bg-transparent border-0 h-auto">
                                <img
                                  src="/assets/images/icons/minus-red-icon.svg"
                                  alt=""
                                  className="img-fluid"
                                  onClick={() => {
                                    handleRemoveCategory(item);
                                  }}
                                />
                              </Button>
                            </div>
                          </h5>
                          {item?.isManuallyAdded ? (
                            <>
                              <Input
                                rootClassName="type-input-custom"
                                placeholder={t("income.sourceIncome")}
                                name={`incomeArr[${index}].type`}
                                value={formik.values.incomeArr[index]?.type}
                                onChange={formik.handleChange}
                                suffix={
                                  <img
                                    src="/assets/images/icons/primary-check-icon.svg"
                                    alt=""
                                    className=""
                                    style={
                                      formik.values.incomeArr[index]?.type?.en
                                        ? { display: "block" }
                                        : { display: "none" }
                                    }
                                  />
                                }
                              />
                              <Input
                                style={{
                                  marginTop: "15px",
                                }}
                                prefix={
                                  formik.values.incomeArr[index]?.amount
                                    ? "$"
                                    : ""
                                }
                                placeholder={t("expenses.commonPlaceholder")}
                                name={`incomeArr[${index}].amount`}
                                suffix={
                                  <img
                                    src="/assets/images/icons/primary-check-icon.svg"
                                    alt=""
                                    className=""
                                    style={
                                      formik.values.incomeArr[index]?.amount
                                        ? { display: "block" }
                                        : { display: "none" }
                                    }
                                  />
                                }
                                value={formatNumber(
                                  formik.values.incomeArr[index]?.amount
                                )}
                                onKeyDown={handleKeyDown}
                                onChange={formik.handleChange}
                              />
                            </>
                          ) : (
                            <>
                              {item?.type?.en?.includes("Other") && (
                                <Input
                                  rootClassName="type-input-custom"
                                  placeholder={t("income.sourceIncome")}
                                  name={`incomeArr[${index}].title`}
                                  value={formik.values.incomeArr[index]?.title}
                                  onChange={formik.handleChange}
                                  suffix={
                                    <img
                                      src="/assets/images/icons/primary-check-icon.svg"
                                      alt=""
                                      className=""
                                      style={
                                        formik.values.incomeArr[index]?.title
                                          ? { display: "block" }
                                          : { display: "none" }
                                      }
                                    />
                                  }
                                />
                              )}
                              <Input
                                style={{
                                  marginTop: "15px",
                                }}
                                prefix={
                                  formik.values.incomeArr[index]?.amount
                                    ? "$"
                                    : " "
                                }
                                placeholder={t("expenses.commonPlaceholder")}
                                name={`incomeArr[${index}].amount`}
                                value={formatNumber(
                                  formik.values.incomeArr[index]?.amount
                                )}
                                onKeyDown={handleKeyDown}
                                onChange={formik.handleChange}
                                suffix={
                                  <img
                                    src="/assets/images/icons/primary-check-icon.svg"
                                    alt=""
                                    className=""
                                    style={
                                      formik.values.incomeArr[index]?.amount
                                        ? { display: "block" }
                                        : { display: "none" }
                                    }
                                  />
                                }
                              />
                            </>
                          )}
                        </CreateProfileCardWrapper>
                        {obj?.isGreenBox && obj?.content}
                      </>
                    );
                  })
                : formik.values.incomeArr.map((item, index) => {
                    return (
                      <CreateProfileCardWrapper collapseInnerCard>
                        <div className="row create-profile-details-row">
                          <div className="col-12">
                            <h6 className="mb-1 d-flex align-items-center justify-content-between">
                              {item?.isManuallyAdded
                                ? t("income.ques6.btnTitle")
                                : item.type?.[i18n.language]}
                              <Button className="p-0 w-auto bg-transparent border-0 h-auto">
                                <img
                                  src="/assets/images/icons/minus-red-icon.svg"
                                  alt=""
                                  className="img-fluid"
                                  onClick={() => {
                                    handleRemoveCategory(item);
                                  }}
                                />
                              </Button>
                            </h6>
                            {item.isManuallyAdded && <p>{item.type}</p>}
                            {item?.type?.en?.includes("Other") && (
                              <p>{item.title}</p>
                            )}
                            <ul className="list-inline mb-0">
                              <li className="list-inline-item">
                                <span className="time-tag">
                                  ${" "}
                                  {formatNumber(item.amount)}
                                </span>
                              </li>
                              <li className="list-inline-item">
                                <span
                                  style={{
                                    background: "#BFBFBF",
                                  }}
                                  className="dot-tag"
                                />
                              </li>
                              <li className="list-inline-item">
                                <span className="time-tag">
                                  {t("monthlyTag")}
                                </span>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </CreateProfileCardWrapper>
                    );
                  }))}
            <CreateProfileCardWrapper>
              <h5
                className="d-flex mb-0 align-items-center justify-content-between w-100"
                onClick={() => {
                  const obj = {
                    type: "",
                    title: "Other income (Please specify)",
                    amount: "",
                    isManuallyAdded: true,
                  };
                  const incomeArr = [...formik.values.incomeArr];
                  incomeArr.push(obj);
                  formik.setFieldValue("incomeArr", incomeArr);
                  handleEditableStep(4);
                }}
              >
                {t("income.ques6.btnTitle")}
                <Button className="p-0 w-auto bg-transparent border-0 h-auto">
                  <img
                    src="/assets/images/icons/plus-icon-green.svg"
                    alt=""
                    className="img-fluid"
                  />
                </Button>
              </h5>
              <p style={{ margin: "10px 0 0 0" }}>
                {userData?.livingInCanada === "yes"
                  ? t("income.ques6.btnDesc")
                  : "This is money you make on the side. Maybe you plan to offer occasional childcare, drive for Uber on the weekend, or sell handmade goods online. All that counts as income!"}
              </p>
            </CreateProfileCardWrapper>
          </div>
        </div>
      </div>
    </div>
  );
};

const Savings = ({
  formik,
  IS_EDITABLE,
  handleEditableStep,
  editableStep,
  handleSavingsObj,
  savingsObj,
  IS_REVIEW,
}) => {
  const userData = useSelector((state) => state.form.userData);
  const { t } = useTranslation();
  useEffect(() => {
    if (
      formik.values?.savings?.length === 0 &&
      formik.values.savingsFlag &&
      !formik.values?.savings[0]?.type
    ) {
      const obj = {
        type: "",
        amount: "",
        id: 1,
      };
      formik.setFieldValue("savings", [obj]);
      handleEditableStep(5);
    } else if (!formik.values.savingsFlag) {
      formik.setFieldValue("savings", []);
    }
  }, [formik.values?.savingsFlag, formik.values?.savings?.length]);
  return (
    <>
      <CreateProfileCardWrapper>
        <h5>
          {userData?.livingInCanada === "yes"
            ? t("income.ques7.title")
            : "Do you have any savings? This can be savings in your home country that you plan on using to pay for living expenses or emergencies in Canada."}
        </h5>
        <Radio.Group
          className="w-100"
          name="savingsFlag"
          value={formik.values.savingsFlag}
          onChange={(e) => {
            if (!e.target.value) {
              formik.setFieldValue("savings", []);
              handleEditableStep(null);
            }
            formik.handleChange(e);
          }}
        >
          <ul className="list-inline mb-0">
            <li>
              <Radio value={true}>{t("income.ques7.options.1")}</Radio>
            </li>
            <li>
              <Radio value={false}>{t("income.ques7.options.2")}</Radio>
            </li>
          </ul>
        </Radio.Group>
      </CreateProfileCardWrapper>
      {typeof formik.values?.savingsFlag === "boolean" &&
        !formik.values?.savingsFlag && (
          <div className="row if-no-select-show-screen">
            <div className="col-12 col-sm-12 col-md-8 col-lg-8 col-xl-9">
              <h5 className="mb-0 w-auto">{t("income.resources.1")}</h5>
            </div>
            <div className="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-3">
              <Button
                className="no-employee-btn"
                onClick={() =>
                  window.open(
                    "https://www.nerdwallet.com/ca/banking/best-high-interest-savings-accounts"
                  )
                }
              >
                {t("newTab")}
              </Button>
            </div>
          </div>
        )}
      {formik.errors["savingsFlag"] && formik.touched["savingsFlag"] && (
        <Typography textAlign={"left"} variant="body2" color="red">
          {formik.errors["savingsFlag"]}
        </Typography>
      )}
      {formik.values?.savingsFlag && IS_REVIEW && !editableStep && (
        <div className="d-flex justify-content-end mb-3">
          <Button
            className="auth-theme-btn auth-theme-btn-outline theme-inner-btn d-flex align-items-center"
            onClick={() => handleEditableStep(5)}
          >
            {t("editBtn")}
          </Button>
        </div>
      )}
      {formik.values.savings?.map((savingItem, idx) => {
        if (editableStep === 5 || (IS_REVIEW && editableStep)) {
          return (
            <CreateProfileCardWrapper>
              <h5 className="d-flex align-items-center justify-content-between w-100">
                <span className="d-flex align-items-center">
                  {t("income.ques7.child1.title")}{" "}
                </span>
                <Button
                  className="bg-transparent border-0 p-0 w-auto shadow-none h-auto"
                  onClick={(e) => {
                    e.stopPropagation();
                    const filteredSavings = formik.values.savings?.filter(
                      (i) => i.id != savingItem.id
                    );
                    formik.setFieldValue("savings", filteredSavings);
                  }}
                >
                  <img
                    src="/assets/images/icons/minus-red-icon.svg"
                    alt=""
                    className="img-fluid"
                  />
                </Button>
              </h5>
              <Input
                rootClassName="normal-input-create-profile"
                placeholder={t("income.ques7.child1.placeholder1")}
                name="type"
                onChange={(e) => {
                  const savingsArr = [...formik.values.savings];
                  savingsArr[idx].type = e.target.value;
                  formik.setFieldValue("savings", savingsArr);
                }}
                value={savingItem?.type}
              />
              <Input
                style={{
                  marginTop: "15px",
                }}
                name="amount"
                prefix={savingItem?.amount ? "$" : " "}
                placeholder={t("income.ques7.child1.placeholder2")}
                onChange={(e) => {
                  const savingsArr = [...formik.values.savings];
                  savingsArr[idx].amount = e.target.value;
                  formik.setFieldValue("savings", savingsArr);
                }}
                min={0}
                value={formatNumber(savingItem?.amount)}
                onKeyDown={handleKeyDown}
              />
            </CreateProfileCardWrapper>
          );
        }
        return (
          <CreateProfileCardWrapper>
            <div className="row create-profile-details-row" style={!IS_REVIEW ? {cursor: "pointer"} : {}} onClick={() => {
              if(!IS_REVIEW) {
              handleEditableStep(5)
              }
            }}>
              <div className="col-12">
                <h6 className="mb-1 d-flex align-items-center justify-content-between">
                  {savingItem.type}
                  <Button
                    className="bg-transparent border-0 p-0 w-auto shadow-none h-auto"
                    onClick={(e) => {
                      e.stopPropagation();
                      const filteredSavings = formik.values.savings?.filter(
                        (i) => i.id != savingItem.id
                      );
                      formik.setFieldValue("savings", filteredSavings);
                    }}
                  >
                    <img
                      src="/assets/images/icons/minus-red-icon.svg"
                      alt=""
                      className="img-fluid"
                    />
                  </Button>
                </h6>
                <ul className="list-inline mb-0">
                  <li className="list-inline-item">
                    <span>$</span>{" "}
                    {savingItem.amount ? formatNumber(savingItem.amount) : ""}
                  </li>
                </ul>
              </div>
            </div>
          </CreateProfileCardWrapper>
        );
      })}
      {formik.values.savingsFlag && (
        <CreateProfileCardWrapper
          onClick={() => {
            handleEditableStep(5);
            const obj = {
              type: "",
              amount: "",
              id: formik.values?.savings?.length + 1,
            };
            if (formik.values.savings?.length > 0) {
              formik.setFieldValue("savings", [...formik.values.savings, obj]);
            } else {
              formik.setFieldValue("savings", [obj]);
            }
          }}
          role="button"
        >
          <h5 className="d-flex align-items-center justify-content-between mb-0 w-100">
            {t("income.ques7.child2")}
            <Button className="bg-transparent border-0 p-0 w-auto shadow-none h-auto">
              <img
                src="/assets/images/icons/plus-icon-green.svg"
                alt=""
                className="img-fluid"
              />
            </Button>
          </h5>
        </CreateProfileCardWrapper>
      )}
    </>
  );
};

const FinalSteps = ({ formik }) => {
  const isMobile = window.innerWidth < 768;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const containerRef = useRef();
  const stepperStatus = useSelector((state) => state.common?.stepperStatus);
  const { t } = useTranslation();
  return (
    <div ref={containerRef}>
      <div className="row mx-0 phase-2-complete-row position-relative">
        <div className="successful-video-tag">
          <img
            alt=""
            src="/assets/images/icons/phase-completion-icon.svg"
            className="completion-icon"
          />
          <img
            src={
              isMobile
                ? "/assets/gifs/mobile-celeb.gif"
                : "/assets/gifs/web-celeb.gif"
            }
            alt="img-fluid"
            className="completion-gif"
          />
        </div>
        <div className="col-12 successful-tag-inner">
          <h1>{t("income.phase2.success")}</h1>
          <h6 className="mb-1">{t("income.phase2.headline1")}</h6>
        </div>
      </div>
      <CreateProfileCardWrapper>
        <h2>{t("income.phase2.title")}</h2>
        <h3>{t("income.phase2.subTitle1")}</h3>
        <h4 className="mb-2">{t("income.phase2.p1")}</h4>
        <h4>{t("income.phase2.p2")}</h4>
        <br />
        <h3>{t("income.phase2.subTitle2")}</h3>
        <h4 className="mb-2">{t("income.phase2.p3")}</h4>
        <h4 className="mb-2">{t("income.phase2.p4")}</h4>
        <h4>{t("income.phase2.p5")}</h4>
        <br />
        <h3>{t("income.phase2.subTitle3")}</h3>
        <h4 className="mb-2">{t("income.phase2.p6")}</h4>
        <h4 className="mb-2">{t("income.phase2.p7")}</h4>
        <h4 className="mb-2">{t("income.phase2.p8")}</h4>
        <h4>{t("income.phase2.p9")}</h4>
        <Button
          className="auth-theme-btn process-with-phase-btn"
          onClick={() => {
            dispatch(
              setStepperStatus({
                ...stepperStatus,
                isIncomeCompleted: true,
              })
            );
            dispatch(setTotalQuestions(31));
            dispatch(setAnsweredQuestions(0));
            navigate(routePaths.expenses);
            dispatch(setInnerStepper(0));
            dispatch(setIncomeData(formik.values));
          }}
        >
          {t("income.proceedBtn")}
        </Button>
      </CreateProfileCardWrapper>
    </div>
  );
};

const stepper = [
  {
    step: 0,
    Component: Employment,
    questions: 1,
  },
  {
    step: 1,
    Component: UserWork,
    questions: 2,
  },
  {
    step: 2,
    Component: MoneyMaking,
    questions: 2,
  },
  {
    step: 3,
    Component: AdditionalIncomeCaregories,
    questions: 1,
    IS_SKIPPABLE: true
  },
  {
    step: 4,
    Component: AdditionalIncome,
    IS_EDITABLE: true,
    questions: 1,
  },
  {
    step: 5,
    Component: Savings,
    IS_EDITABLE: true,
    questions: 2,
    IS_SKIPPABLE: true
  },
  {
    step: 6,
    Component: null,
    IS_REVIEW: true,
  },
  {
    step: 7,
    Component: FinalSteps,
    IS_FINAL: true,
  },
];

const EditIncome = () => {
  const [innerStepper, setInnerStepper] = useState(0);
  const dispatch = useDispatch();
  const foundItem = stepper.find((i) => i.step == innerStepper);
  const [editableStep, setEditableStep] = useState(null);
  const [savingsObj, setSavingsObj] = useState({ type: "", amount: "" });
  const containerRef = useRef();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const formik = useFormik({
    initialValues: {
      employment: "",
      profession: "",
      jobType: "",
      categories: [],
      incomeArr: [],
      savingsFlag: "",
      savings: [],
      incomeFrequency: "monthly",
      howMuchMoney: "",
      currentStep: 0,
    },
    onSubmit: (values) => onFinish(values),
  });
  const checkConfirmDisabled = () => {
    const { incomeArr, savings } = formik.values;
    let flag = false;
    if ((innerStepper === 4 || foundItem?.IS_REVIEW) && incomeArr?.length > 0) {
      flag = !incomeArr.every((item) =>
        item.amount != "" ? item.amount : false
      );
      if (flag) {
        return flag;
      }
    }
    if ((innerStepper === 5 || foundItem?.IS_REVIEW) && savings?.length > 0) {
      flag = !savings.every((item) => {
        return item?.amount && item?.type;
      });
      if (flag) {
        return flag;
      }
    }
    return flag;
  };
  const handleNextStep = (IS_SKIP) => {
    if (!foundItem?.IS_REVIEW) {
      if (formik.values.employment === "no" && innerStepper === 0) {
        setInnerStepper(3);
        formik.setFieldValue("currentStep", 3);
      } else {
        setInnerStepper(innerStepper + 1);
        formik.setFieldValue("currentStep", formik.values.currentStep + 1);
      }
    } else if (foundItem?.IS_REVIEW) {
      navigate("/settings/edit-form/expenses");
      dispatch(setMenuTitle(t("commonStepper.section3")));
    }
    if (innerStepper === 3) {
      if (IS_SKIP) {
        formik.setFieldValue("incomeArr", []);
        formik.setFieldValue("categories", []);
        setInnerStepper(innerStepper + 2);
        formik.setFieldValue("currentStep", formik.values.currentStep + 2);
      } else {
        setInnerStepper(innerStepper + 1);
        formik.setFieldValue("currentStep", formik.values.currentStep + 1);
        setEditableStep(4);
        formik.setFieldValue("currentStep", 4);
      }
    }
    dispatch(setLoading(false));
  };
  const getTotalQuestions = () => {
    const { employment, savingsFlag } = formik.values;
    if (employment === "yes" && savingsFlag) {
      dispatch(setTotalQuestions(8));
    }
    if (employment === "no" && savingsFlag) {
      dispatch(setTotalQuestions(4));
    }
    if (employment === "yes" && !savingsFlag) {
      dispatch(setTotalQuestions(7));
    }
    if (employment === "no" && !savingsFlag) {
      dispatch(setTotalQuestions(3));
    }
  };

  const getTotalAnswers = () => {
    let num = 0;
    const {
      employment,
      jobType,
      categories,
      incomeArr,
      savingsFlag,
      savings,
      incomeFrequency,
      howMuchMoney,
    } = formik.values;
    if (employment) {
      num += 1;
    }
    if (employment === "yes" && jobType) {
      num += 2;
    }
    if (employment === "yes" && howMuchMoney && incomeFrequency) {
      num += 2;
    }
    if (typeof savingsFlag === "boolean") {
      num += 1;
    }
    if (savingsFlag && savings?.length > 0) {
      num += 1;
    }
    if (
      incomeArr?.length > 0 &&
      incomeArr.every((item) => (item.amount != "" ? item.amount : false))
    ) {
      num += 1;
    }
    if (categories?.length > 0) {
      num += 1;
    }
    dispatch(setAnsweredQuestions(num));
  };

  useEffect(() => {
    getTotalQuestions();
    getTotalAnswers();
  }, [formik.values]);

  const onFinish = (values, IS_SKIP) => {
    dispatch(setLoading(true));
    const payload = getPayload(IS_SKIP);
    UpdateIncome(payload)
      .then((resp) => {
        if (editableStep !== 4 && editableStep !== 5) {
          handleNextStep(IS_SKIP);
        }
      })
      .catch((Err) => {
        message.error(Err.message[i18n.language]);
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };
  const getPayload = (IS_SKIP) => {
    const currentMonth = format(new Date(), "MM-yyyy");
    const obj = {};
    obj.step =
      editableStep === 4 || editableStep === 5
        ? innerStepper
        : innerStepper + 1;
    obj.isEdit = true;
    obj.currentMonth = currentMonth;
    if (innerStepper === 0) {
      obj.isEmployed = formik.values?.employment;
      obj.incomeAmount = Number(
        String(formik.values.howMuchMoney)?.replace(/,/g, "")
      );
    } else if (innerStepper === 1) {
      obj.workType = formik.values.profession;
      obj.employmentType = formik.values.jobType;
    } else if (innerStepper === 2) {
      obj.incomeAmount = Number(
        String(formik.values.howMuchMoney)?.replace(/,/g, "")
      );
      obj.incomeType = formik.values.incomeFrequency;
    } else if (innerStepper === 3 && IS_SKIP) {
      obj.additionalIncome = [];
    } else if (innerStepper === 4) {
      obj.additionalIncome = formik.values.incomeArr?.map((i) => {
        const otherOpt = i.type?.en || i.type;
        return {
          ...i,
          title:
            i.isManuallyAdded || otherOpt?.includes("Other") ? i.title : "",
          type: i.isManuallyAdded ? i.type : i.type?.en || i.type,
          amount: Number(String(i.amount)?.replace(/,/g, "")),
        };
      });
    } else if (innerStepper === 5) {
      obj.savings = formik.values.savings?.map((i) => ({
        ...i,
        amount: Number(String(i.amount)?.replace(/,/g, "")),
      }));
    } else if (innerStepper === 6) {
      obj.isEmployed = formik.values?.employment;
      obj.workType = formik.values.profession;
      obj.employmentType = formik.values.jobType;
      obj.incomeAmount = Number(
        String(formik.values.howMuchMoney)?.replace(/,/g, "")
      );
      obj.incomeType = formik.values.incomeFrequency;
      obj.additionalIncome = formik.values.incomeArr?.map((i) => {
        const otherOpt = i.type?.en || i.type;
        return {
          ...i,
          title:
            i.isManuallyAdded || otherOpt?.includes("Other") ? i.title : "",
          type: i.isManuallyAdded ? i.type : i.type?.en || i.type,
          amount: Number(String(i.amount)?.replace(/,/g, "")),
        };
      });
      obj.savings = formik.values.savings?.map((i) => ({
        ...i,
        amount: Number(String(i.amount)?.replace(/,/g, "")),
      }));
      obj.isIncomeCompleted = true;
    }
    return obj;
  };
  const checkSubmitDisabled = () => {
    const {
      currentStep,
      employment,
      jobType,
      howMuchMoney,
      incomeFrequency,
      categories,
      savingsFlag,
      savings,
    } = formik.values;
    if ((currentStep === 0 || foundItem?.IS_REVIEW) && !employment) {
      return true;
    } else if (
      (currentStep === 1 || foundItem?.IS_REVIEW) &&
      employment === "yes" &&
      !jobType
    ) {
      return true;
    } else if (
      (currentStep === 2 || foundItem?.IS_REVIEW) &&
      employment === "yes" &&
      (!howMuchMoney || !incomeFrequency)
    ) {
      return true;
    } else if (currentStep === 3 && categories?.length === 0) {
      return true;
    } else if (
      (currentStep === 5 || foundItem?.IS_REVIEW) &&
      ((savingsFlag && savings?.length === 0) ||
        typeof savingsFlag != "boolean")
    ) {
      return true;
    }
    return false;
  };
  const handlePreviousStep = () => {
    if (innerStepper > 0) {
      if (innerStepper === 5 || innerStepper === 6) {
        const filteredArr = formik.values?.savings.filter(
          (i) => i.type && i.amount
        );
        formik.setFieldValue("savings", filteredArr);
      }
      if (innerStepper === 3 && formik.values.employment === "no") {
        setInnerStepper(0);
        formik.setFieldValue("currentStep", 0);
      } else if (innerStepper === 5 && formik.values.incomeArr?.length === 0) {
        setInnerStepper(3);
        formik.setFieldValue("currentStep", 3);
      } else {
        setInnerStepper(innerStepper - 1);
        formik.setFieldValue("currentStep", innerStepper - 1);
        setEditableStep(null);
      }
    }
    setEditableStep(null);
  };

  useEffect(() => {
    if (foundItem?.IS_REVIEW || !formik.values?.employment) {
      fetchIncomeDetails();
    }
  }, [innerStepper, foundItem?.IS_REVIEW]);

  const fetchIncomeDetails = () => {
    dispatch(setLoading(true));
    const currentMonth = format(new Date(), "MM-yyyy");
    GetIncomeDetails({ currentMonth })
      .then(async (resp) => {
        const { data } = resp;
        formik.setValues({
          employment: data?.isEmployed || "",
          profession: data?.workType || "",
          jobType: data?.employmentType || "",
          categories: data?.additionalIncome?.map((i) => i.type) || [],
          incomeArr:
            data?.additionalIncome?.map((i) => ({
              ...i,
              amount: String(isFalsyExceptZero(i.amount) ? "" : i.amount),
            })) || [],
          savings:
            data?.savings?.length > 0
              ? data?.savings?.map((i) => ({
                  ...i,
                  amount: String(isFalsyExceptZero(i.amount) ? "" : i.amount),
                }))
              : [
                  {
                    type: "",
                    amount: "",
                    id: 1,
                  },
                ],
          incomeFrequency: data?.incomeType || "monthly",
          howMuchMoney: String(
            isFalsyExceptZero(data?.incomeAmount) ? "" : data?.incomeAmount
          ),
          currentStep: 0,
        });
        if (data?.savings?.length > 0) {
          formik.setFieldValue("savingsFlag", true);
        } else if (foundItem?.IS_REVIEW && data?.savings?.length === 0) {
          formik.setFieldValue("savingsFlag", false);
        }
      })
      .catch((Err) => {
        message.error(Err.message[i18n.language]);
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };

  const getFilteredArr = () => {
    const { employment, categories } = formik.values;
    let stepperArr = [...stepper].filter((i) => !i.IS_FINAL && i.step != 6);
    if (employment === "no") {
      stepperArr = stepperArr.filter((i) => i.step != 1 && i.step != 2);
    }
    if (categories?.length === 0) {
      stepperArr = stepperArr.filter((i) => i.step != 4);
    }
    return stepperArr;
  };
  useEffect(() => {
    if (containerRef) {
      containerRef.current.scrollTo({
        behavior: "smooth",
        block: "start",
        inline: "nearest",
      });
      window.scrollTo({ top: 0 });
    }
  }, [containerRef, innerStepper]);
  return (
    <div
      className={`income-details-right ${
        foundItem?.step === 0 || foundItem?.IS_FINAL ? "previous-hidden" : ""
      }`}
      ref={containerRef}
    >
      {/*header*/}
      <form onSubmit={formik.handleSubmit}>
        {innerStepper != 0 && (
          <CreateProfileHeader
            handlePreviousStep={handlePreviousStep}
            step={foundItem?.step}
            IS_FINAL={foundItem?.IS_FINAL}
            isEdit={true}
          />
        )}
        <div className="only-mobile-show">
          <Button
            className="previous-btn w-auto d-flex align-items-center border-0 shadow-none rounded-0 bg-transparent"
            onClick={handlePreviousStep}
          >
            <img
              src="/assets/images/icons/back-arrow-gray-icon.svg"
              className="img-fluid"
              alt=""
            />
            {t("prevQues")}
          </Button>
        </div>
        <CreateProfileCenterWrapper
          className={foundItem?.IS_FINAL ? "is-final" : ""}
        >
          {innerStepper === 6 ? (
            <div className="row">
              <div className="col-12 review-inform-div">
                <h6 className="review-tag">{t("reviewInfo")}</h6>
                {getFilteredArr().map((Item) => {
                  return (
                    <Item.Component
                      onFinish={onFinish}
                      formik={formik}
                      handleEditableStep={(num) => setEditableStep(num)}
                      editableStep={editableStep}
                      IS_EDITABLE={foundItem?.IS_EDITABLE}
                      savingsObj={savingsObj}
                      handleSavingsObj={(data) => setSavingsObj(data)}
                      IS_REVIEW={true}
                    />
                  );
                })}
              </div>
            </div>
          ) : foundItem ? (
            <foundItem.Component
              onFinish={onFinish}
              formik={formik}
              handleEditableStep={(num) => setEditableStep(num)}
              editableStep={editableStep}
              IS_EDITABLE={foundItem?.IS_EDITABLE}
              savingsObj={savingsObj}
              handleSavingsObj={(data) => setSavingsObj(data)}
              innerStepper={innerStepper}
            />
          ) : (
            <></>
          )}
        </CreateProfileCenterWrapper>
        {!foundItem?.IS_FINAL && (
          <CreateProfileFooter
            IS_EDITABLE={foundItem?.IS_EDITABLE}
            handleEditableStep={setEditableStep}
            editableStep={editableStep}
            savingsObj={savingsObj}
            emptySavingObj={() => setSavingsObj(null)}
            formik={formik}
            IS_SKIPPABLE={foundItem?.IS_SKIPPABLE}
            handleNextStep={handleNextStep}
            innerStepper={innerStepper}
            IS_INCOME={true}
            checkSubmitDisabled={checkSubmitDisabled}
            checkConfirmDisabled={checkConfirmDisabled}
            IS_REVIEW={foundItem?.IS_REVIEW}
            onFinish={onFinish}
          />
        )}
      </form>
    </div>
  );
};

export default EditIncome;
